import { render, staticRenderFns } from "./2f.vue?vue&type=template&id=01f492af&scoped=true&"
import script from "./2f.vue?vue&type=script&lang=js&"
export * from "./2f.vue?vue&type=script&lang=js&"
import style0 from "./2f.vue?vue&type=style&index=0&id=01f492af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f492af",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VImg,VRow,VTextField})
